import React, {Component} from 'react';
import {connect} from 'react-redux';
import PolicyTab from "../components/policyTab";
import {requestGetSolicitorDetails, requestGetLawsysDetails} from "../actions/manageSolicitorAccount";
import moment from "moment";
import {requestGetUnderwriterOfSpecificSolicitorGroup} from "../actions/groups";
import {getApplicationIpt} from "../actions/policyTab";
import _ from 'lodash'
import accounting from 'accounting';
import '../style/dots.css';
import {
	changeActiveTab,
	getApplicationPolicyWording,
	requestApplicationPremiumSettings,
	getPolicySchedule
} from "../actions/applicationPolicy";
import {_getFileFromBase64, isGatewayPlutusLawsys} from "../helpers/functions";
import {
	getAdvancedDisbursementsOfAPolicy,
	getAdvanceDisbursementsStatementMessages
} from "../actions/advancedDisbursements";
import {CURRENCY, POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE} from "../helpers/variables";
import { PRE_LIVE_POLICY_STATUSES } from '../helpers/constants';

class PolicyFormHOC extends Component {

	componentWillMount() {
		let route = this.props.router.location.pathname;
		let splitedRoute = _.split(route, '/', 4);
		let splitId = splitedRoute[3];

		if (PRE_LIVE_POLICY_STATUSES.includes(this.props.selectedApp.policyStatusMachineName)) {
			this.props.selectActiveTab(POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE.application)
		}

		this.props.getLawsysDetails(this.props.policy.lawsysId);
		this.props.getApplicationIpt(splitId);
        this.props.getApplicationPremiumSettings(_.last(this.props.match.url.split('/')));

		// Review: GPL policies DO have a wordingId - the ARAG Useful Contacts placeholder - so this
		// used to fire for them too, fetching ~28 KB of base64 that policyTab.js:87 then refuses to
		// render (it short-circuits on !isGpl) AND gating the whole tab behind fetchingWording,
		// because policyTab.js:34 returns <CenteredDots/> while that flag is set. Their real wording
		// and IPID come from the GPL documents modal instead, so skip the request entirely.
		if (this.props.policy.wordingId && !isGatewayPlutusLawsys(this.props.selectedApp?.systemsOfRecordId))
		{
        	this.props.getApplicationPolicyWording({wordingId: this.props.policy.wordingId})
		}
    }

	//group Ranges Of Damages
	groupRangesOfDamages = (damages) => {
		let integerDamages = [];
		for (let i = 0; i < damages.length; i++) {
			let damageRanges = damages[i].range.match(/\d+/g);
			if (damageRanges.length === 4) {
				integerDamages.push(damageRanges[0] + damageRanges[1]);
				integerDamages.push(damageRanges[2] + damageRanges[3]);
			}
			else if (damageRanges.length === 5) {
				integerDamages.push(damageRanges[0] + damageRanges[1]);
				integerDamages.push(damageRanges[2] + damageRanges[3] + damageRanges[4]);
			}
			else if (damageRanges.length === 3) {
				integerDamages.push(damageRanges[0] + damageRanges[1] + damageRanges[2]);
			}
		}
		integerDamages = integerDamages.map(damage => {
			return parseInt(damage)
		});
		let sortedIntegerDamages = _.sortBy(integerDamages);

		let indexedToBeRemoved = [];
		for (let i = 0; i < sortedIntegerDamages.length; i++) {
			if (i + 1 <= sortedIntegerDamages.length) {
				if (sortedIntegerDamages[i] + 1 === sortedIntegerDamages[i + 1] || (sortedIntegerDamages[i] === sortedIntegerDamages[i + 1])) {
					indexedToBeRemoved.push(i);
					indexedToBeRemoved.push(i + 1)
				}
			}
		}

		let newDamageRanges = [];
		for (let i = 0; i < sortedIntegerDamages.length; i++) {
			if (!indexedToBeRemoved.includes(i)) {
				newDamageRanges.push(sortedIntegerDamages[i])
			}
		}

		let stringDamageRanges = [];
		for (let i = 0; i < newDamageRanges.length; i = i + 2) {
			if (i + 1 < newDamageRanges.length) {
				stringDamageRanges.push(accounting.formatMoney(newDamageRanges[i], `${CURRENCY} `, 0) + ' - ' + accounting.formatMoney(newDamageRanges[i + 1], `${CURRENCY} `, 0))
			}
			else if (i + 1 === newDamageRanges.length) {
				stringDamageRanges.push('Over ' + accounting.formatMoney(newDamageRanges[i], `${CURRENCY} `, 0))
			}
		}
		return (stringDamageRanges)
	};

	findQuestionAnswer = (questionName) => {
		let selectedApp = this.props.selectedApp;
		let questionId = null;
		let questionType = null;
		for (let i = 0; i < this.props.questions.length; i++) {

			if (this.props.questions[i].machineName === questionName) {
				questionId = this.props.questions[i].id;
				questionType = this.props.questions[i].inputType;
				break;
			}
		}
		if (!questionId) {
			return '';
		}
		for (let i = 0; i < selectedApp.applicationAnswersDtos.length; i++) {
			if (selectedApp.applicationAnswersDtos[i].questionId === questionId) {
				if (questionType === 'calendar') {
					return moment(selectedApp.applicationAnswersDtos[i].date).format("DD/MM/YYYY")
				}
				if(questionType === 'text'){
					return selectedApp.applicationAnswersDtos[i].text
				}
			}
		}
		return '';
	};

    _downloadWording = () => {
        _getFileFromBase64({
            encodedFile: this.props.wording.encodedFile,
            name: 'Policy_Wording_' + this.props.wording.name,
            fileType: this.props.wording.fileType,
        });
    };

    _getApplicationPolicyTrack = () => {
    	try {
			const trackQuestion = _.find(this.props.questions, question => {
				return question.machineName === 'LikelyClaimsTrack'
			});
			if(!trackQuestion) { return ''}

			const trackQuestionAnswer = _.find(this.props.selectedApp.applicationAnswersDtos, answer => {
				return answer.questionId === trackQuestion.id
			});
			if(!trackQuestionAnswer) {return ''}

			const trackQuestionOption = _.find(trackQuestion.options, option => {
				return option.id === trackQuestionAnswer.optionId
			});
			if(!trackQuestionOption) {return ''}

			return `(${trackQuestionOption.name})`
        } catch (e) {
			return ''
        }
	};

	// US 100864: the firm shown on the schedule is resolved server-side from the policy, so the
	// logged-in user's firm id is no longer sent.
	downloadPolicySchedule = () => {
		this.props.getPolicySchedule({ applicationId: this.props.policy.id });
	}

	render() {
		return (
            <PolicyTab
                applicationPolicyTrack={this._getApplicationPolicyTrack()}
                fetchingSchedules={this.props.policyTab.fetchingSchedules}
                fetchingIpt={this.props.policyTab.fetchingIpt}
                fetchingUnderwriter={this.props.policyTab.fetchingUnderwriter}
                fetchingSolicitorDetails={this.props.policyTab.fetchingSolicitorDetails}
                fetchingPremiumSettings={this.props.premiumSettingsIndicator}
                haveDataRequired={this.props.policyTab.haveDataRequired}
                groupRangesOfDamages={this.groupRangesOfDamages}
                ipt={this.props.policyTab.ipt}
                schedules={this.props.policyTab.schedules}
                underwriter={this.props.policyTab.underwriter}
                footer={this.props.policyTab.scheduleFooter}
                findQuestionAnswer={this.findQuestionAnswer}
                applicationPremiumSettings={this.props.applicationPremiumSettings}
                selectedApp={this.props.selectedApp}
                lawsysFirm={this.props.lawsysDetails}
                allPossibleDamages = {this.props.damages}
				downloadPolicySchedule={this.downloadPolicySchedule}
                failedToGetWordingMsg={this.props.failedToGetWordingMsg}
                _downloadWording={this._downloadWording}
                wordingId={this.props.wordingId}
                wording={this.props.wording}
                policy={this.props.policy}
                fetchingWording={this.props.fetchingWording}
				fetchingPolicySchedule = {this.props.fetchingPolicySchedule}
            />
		)
	}

}

const mapStateToProps = (state) => {
	return {
		policyTab: state.policyTab,
		questions: state.newApplication.questions,
		user: state.user,
		lawsysFirms: state.lawsysFirms,
		applicationPremiumSettings: state.applicationPolicy.premiumSettings,
		premiumSettingsIndicator: state.applicationPolicy.premiumSettingsIndicator,
		solicitorDetails: state.manageSolicitorAccount.solicitorData,
		lawsysDetails: state.manageSolicitorAccount.lawsysData,
		damages: state.damages,
        fetchingPolicySchedule: state.applicationPolicy.fetchingPolicySchedule,
        fetchingWording: state.applicationPolicy.fetchingWording,
        wordingFile: state.applicationPolicy.wording,
        wordingId: state.applicationPolicy.wordingId,
        wording: state.applicationPolicy.wording,
        policy: state.newApplication.selectedApplication,
        failedToGetWordingMsg: state.applicationPolicy.failedToGetWording,
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		getSolicitorDetails: (id) => {
			dispatch(requestGetSolicitorDetails(id))
		},
		getLawsysDetails: (id) => {
			dispatch(requestGetLawsysDetails(id))
		},
		requestGetUnderwriterOfSpecificSolicitorGroup: (groupId) => {
			dispatch(requestGetUnderwriterOfSpecificSolicitorGroup(groupId))
		},
		getApplicationIpt: (applicationId) => {
			dispatch(getApplicationIpt(applicationId))
		},
        getApplicationPremiumSettings: (id) => {
            dispatch(requestApplicationPremiumSettings({id:id}));
        },
        getApplicationPolicyWording: (payload) => {
            dispatch(getApplicationPolicyWording(payload))
		},
		getAdvancedDisbursementsOfAPolicy: (policyId) => {
			dispatch(getAdvancedDisbursementsOfAPolicy(policyId))
		},
		getAdvanceDisbursementsStatementMessages: (payload) => {
			dispatch(getAdvanceDisbursementsStatementMessages(payload))
		},
		selectActiveTab: (tab) => {
			dispatch(changeActiveTab(tab))
		},
		getPolicySchedule: (payload) => {
			dispatch(getPolicySchedule(payload))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(PolicyFormHOC);
